/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Box } from "@mui/material";
import parse from "html-react-parser";
import React, { useMemo } from "react";

import { descriptionStyleMap } from "./descriptionStyleMap";
import { preprocess } from "./preprocess";
import { createReplaceOptions } from "./renderDescription";

// Build the replace options once at module level — descriptionStyleMap is a
// static constant so this never needs to be re-created at runtime.
const replaceOptions = createReplaceOptions(descriptionStyleMap);

interface LongDescriptionProps {
  /** Raw HTML string from D365 `onlineLongDescription`. */
  html: string;
}

/**
 * Renders a D365 Online Long Description with consistent Farmlands PRO styling.
 *
 * This component is intentionally pure (no Redux/context dependencies) so that
 * it can be rendered in isolation in Storybook or unit tests.
 *
 * Presentation rules live in `descriptionStyleMap.tsx`. Edit that file to
 * change the visual treatment of any HTML structure.
 */
export const LongDescription = ({ html }: LongDescriptionProps) => {
  const content = useMemo(() => parse(preprocess(html), replaceOptions), [html]);

  return <Box>{content}</Box>;
};
